import { FC } from 'react';

type Props = {
	className?: string;
};

const HomeIconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='inherit'
			stroke='none'
			className={className}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M7.63236 2.51475C8.40317 1.95084 9.14094 1.61182 9.99906 1.61182C10.8572 1.61182 11.595 1.95084 12.3658 2.51475C13.1138 3.06197 13.9563 3.86988 15.0194 4.88928L15.0481 4.91677L17.1583 6.8661V11.2719C17.1583 12.7755 17.1583 13.9664 17.033 14.8985C16.904 15.8578 16.6323 16.6342 16.02 17.2466C15.4077 17.8588 14.6312 18.1306 13.6719 18.2596C12.7399 18.3848 11.5489 18.3848 10.0452 18.3848H9.95284C8.44924 18.3848 7.25825 18.3848 6.32616 18.2596C5.36689 18.1306 4.59047 17.8588 3.97815 17.2466C3.36585 16.6342 3.09411 15.8578 2.96514 14.8985C2.83982 13.9664 2.83984 12.7755 2.83984 11.2718V6.8661L4.95006 4.91676L4.97873 4.88927C6.04183 3.86988 6.88438 3.06197 7.63236 2.51475ZM9.99538 13.0666C9.43254 13.0666 8.97632 13.5244 8.97632 14.0893C8.97632 14.6542 9.43254 15.1121 9.99538 15.1121C10.5536 15.1121 11.0218 14.6525 11.0218 14.0893C11.0218 13.5261 10.5536 13.0666 9.99538 13.0666Z'
				fill='inherit'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M8.47889 3.67031C7.8183 4.15359 7.0454 4.89234 5.93803 5.95417L2.38448 9.36157C2.05831 9.67428 1.54038 9.6634 1.22763 9.33727C0.91488 9.01114 0.925755 8.49314 1.25191 8.18043L4.84799 4.73226C5.90277 3.72082 6.75361 2.90495 7.51268 2.34963C8.30211 1.77208 9.0819 1.40723 10.0002 1.40723C10.9184 1.40723 11.6982 1.77208 12.4876 2.34963C13.2467 2.90496 14.0975 3.72082 15.1523 4.73227L18.7484 8.18043C19.0745 8.49314 19.0854 9.01114 18.7727 9.33727C18.46 9.6634 17.942 9.67428 17.6159 9.36157L14.0623 5.95417C12.9549 4.89234 12.182 4.1536 11.5214 3.67031C10.881 3.20179 10.4375 3.04362 10.0002 3.04362C9.56284 3.04362 9.11929 3.20179 8.47889 3.67031Z'
				fill='inherit'
			/>
		</svg>
	);
};

export default HomeIconSolid;
